(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-image-comparison]').forEach(section=>{const range=section.querySelector('[data-comparison-range]');if(!range)return;range.addEventListener('input',()=>section.style.setProperty('--comparison-position',`${range.value}%`));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-recommendations]').forEach(section=>{
  if(!section.dataset.url||!('IntersectionObserver'in window))return;
  const observer=new IntersectionObserver(entries=>{
    if(!entries[0].isIntersecting)return;
    observer.unobserve(section);
    fetch(section.dataset.url)
      .then(response=>response.text())
      .then(text=>{
        const html=new DOMParser().parseFromString(text,'text/html');
        const fresh=html.querySelector('[data-recommendations]');
        if(fresh&&fresh.innerHTML.trim())section.innerHTML=fresh.innerHTML;
      })
      .catch(()=>{});
  },{rootMargin:'0px 0px 300px 0px'});
  observer.observe(section);
});

  } catch(e) { console.error(e); }
})();
})();
